import { StyleSheet } from 'react-native';

import Theme from 'Theme';
import { Device } from 'DeviceUtils';

let baseStyles = {
    container: {
        position: 'relative',
        ...StyleSheet.absoluteFill,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        flex: 1,
        width: '100%',
        height: '100%'
    },
    containerHeightThreeOptions: {
        minHeight: 340
    },
    containerHeightTwoOptions: {
        minHeight: 280
    },
    containerHeight: {
        minHeight: 220
    },
    containerHeightZero: {
        minHeight: 0
    },
    innerContainer: {
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        height: '100%'
    },
    lastItem: {
        marginBottom: 10
    },
    backgroundContainer: {
        backgroundColor: 'rgba(255, 0, 0, .15)'
    },
    iconCloseWrapper: { position: 'absolute', width: '100%', height: '100%' },
    iconClose: {
        position: 'absolute',
        top: 20,
        right: 25,
        width: 36,
        height: 36
    },
    settingsContainerPadding: {}
};

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        container: {
            position: 'absolute',
            borderRadius: 5,
            borderWidth: 1,
            borderColor: Theme.secondaryButtonBorderColor,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            bottom: Theme.playerFooterHeight ? 70 : 30,
            right: 20,
            padding: '2%',
            paddingTop: '1%',
            paddingBottom: '5%',
            flexDirection: 'column-reverse'
        },
        innerContainer: {
            flex: 1,
            padding: '2%',
            paddingTop: '1%',
            alignContent: 'center',
            flexDirection: 'column-reverse',
            justifyContent: 'flex-end',
            width: '100%',
            height: '100%'
        },
        backgroundContainer: {
            height: 0,
            width: 0
        },
        iconCloseWrapper: {},
        iconClose: {
            display: 'flex',
            position: 'relative',
            top: 0,
            left: 0
        }
    };
}

if (Device.isTablet) {
    baseStyles = {
        ...baseStyles,
        container: {
            position: 'absolute',
            bottom: 0,
            paddingBottom: Theme.playerFooterHeight ? 80 : 30,
            right: 10,
            flexDirection: 'column-reverse',
            minWidth: '40%'
        },
        innerContainer: {
            flex: 1,
            paddingRight: '5%',
            alignContent: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
        },
        backgroundContainer: {
            borderRadius: 5,
            borderWidth: 1,
            borderColor: Theme.secondaryButtonBorderColor,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            position: 'absolute',
            height: '100%',
            width: '100%',
            marginBottom: Theme.playerFooterHeight ? 85 : 30
        },
        iconCloseWrapper: {},
        iconClose: {
            marginTop: '2%',
            display: 'flex',
            height: 38,
            width: 28,
            paddingBottom: 20
        },
        dropbox: {},
        dropdownTop: {
            top: 60,
            zIndex: 100,
            elevation: 100
        },
        dropdownTopZero: {
            top: 0,
            zIndex: 100,
            elevation: 100
        },
        settingsContainerPadding: {
            paddingVertical: 20,
            paddingLeft: 30
        }
    };
}

export default StyleSheet.create(baseStyles);
